module.exports = __webpack_public_path__ + "static/img/witpark.c328227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/witpark.png
// module id = dYlg
// module chunks = 1